module.exports = __webpack_public_path__ + "img/default.e01a3c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default.jpg
// module id = ZTHz
// module chunks = 4